export { TruncateModule, TRUNCATE_PIPES } from './truncate.module';
//# sourceMappingURL=index.js.map